'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _chartColors = require('./chart-colors');

var _chartColors2 = _interopRequireDefault(_chartColors);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  animation: {
    duration: 500,
    easing: 'out',
    startup: true
  },
  legend: {
    position: 'bottom'
  },
  chartArea: {
    width: '70%',
    top: 0,
    left: '35%'
  },
  colors: _chartColors2.default,
  annotations: {
    alwaysOutside: true,
    style: 'point',
    textStyle: {
      fontSize: 14,
      color: '#000'
    }
  },
  defaultColor: _chartColors.geographyColors[0],
  colorAxis: {
    colors: _chartColors.geographyColors,
    minValue: 0
  }
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Chart/chart-default-options.js
// module id = 1965
// module chunks = 1